var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function dialog(theme) {
    var _a, _b, _c, _d;
    return {
        MuiDialog: {
            styleOverrides: {
                paper: function (_a) {
                    var _b;
                    var ownerState = _a.ownerState;
                    return (__assign((_b = { boxShadow: theme.customShadows.dialog }, _b[theme.breakpoints.down('md')] = {
                        width: '100%',
                        maxHeight: 'calc(100svh - 32px)'
                    }, _b.borderRadius = Number(theme.shape.borderRadius) * 2, _b), (!ownerState.fullScreen && {
                        margin: theme.spacing(2)
                    })));
                },
                paperFullScreen: {
                    borderRadius: 0
                }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: (_a = {
                        padding: theme.spacing(3)
                    },
                    _a[theme.breakpoints.down('sm')] = {
                        padding: theme.spacing(1, 2)
                    },
                    _a)
            }
        },
        MuiDialogContent: {
            styleOverrides: {
                root: (_b = {
                        padding: theme.spacing(0, 3)
                    },
                    _b[theme.breakpoints.down('sm')] = {
                        padding: theme.spacing(0, 2)
                    },
                    _b),
                dividers: (_c = {
                        borderTop: 0,
                        borderBottomStyle: 'dashed',
                        paddingBottom: theme.spacing(3)
                    },
                    _c[theme.breakpoints.down('sm')] = {
                        paddingBottom: theme.spacing(1)
                    },
                    _c)
            }
        },
        MuiDialogActions: {
            styleOverrides: {
                root: (_d = {
                        padding: theme.spacing(3)
                    },
                    _d[theme.breakpoints.down('sm')] = {
                        padding: theme.spacing(1)
                    },
                    _d[theme.breakpoints.down('md')] = {
                        '& > *': {
                            flex: '1 1 auto'
                        }
                    },
                    _d['& > :not(:first-of-type)'] = {
                        marginLeft: theme.spacing(1, 2)
                    },
                    _d)
            }
        }
    };
}
